import React from 'react';
import { withRouter } from 'react-router-dom';
import { Grid, Row, Col, Form } from 'react-bootstrap';
// src
import { LANDING, CHANGE_PWD, LOGIN_PATH as path } from '../../routes/routes_production.js';
import { PostRequest } from '../../api/PostRequest.js';
import logo from '../../img/logo.png';
import '../styles/commonStyles.css';
import '../styles/sharedComponentsStyles.css';
import { CommonFormField, CommonFormButton, CommonAlertBox } from './CommonFields.js';

const Login = ({ history }) => (		
  <Grid>
    <Row className="show-grid">      
      <Col xs={12} className="jumbotron backgroundWhite">
        <img src={logo} alt="Logo Imperial" className="img-responsive center-block" />
      </Col>      
      <Col xs={12}>
        <h1 className="pageTitle">Autenticazione</h1>
        <h2 className="pageSubTitle">Inserisci i dati di accesso</h2>                      
      </Col>
      <LoginForm history={history} />
    </Row>
  </Grid>
);

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      request: 'login',
      nomeUtente: '', 
      password: '',
      showAlertBox: null,       
    };

    this.handleLogin = this.handleLogin.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

	render() {
    const { showAlertBox } = this.state;

		return(
				<Row className="show-grid">					
					<Col xs={12} md={12}>
						<Form>
              <CommonFormField name="nomeUtente" type="text" 
                              label="Nome utente" handler={this.handleChange}                             
                              placeholder="Inserisci il tuo nome utente" />
			        <CommonFormField name="password" type="password" 
                              label="Password" handler={this.handleChange}                               
                              placeholder="Inserisci la tua password" />
              <CommonFormButton handler={this.handleLogin} 
                              text="Login" bsStyle="btn-primary btn-outline" />  
              { showAlertBox? 
                <CommonAlertBox label="Autenticazione fallita!" 
                  caption="Le credenziali inserite non sono state accettate." /> 
                : null 
              }
			      </Form>	
					</Col>                
	      </Row>        
			);
	}	

  handleChange(event) {    
    this.setState({ [event.target.name]: event.target.value });
  }

  handleLogin() {
  	const { history } = this.props;
    const { nomeUtente, password } = this.state;
    const parent = this;
    
    if(nomeUtente === '' || password === '') {
      this.setState({ showAlertBox: true, });   
    } else {
      PostRequest(path, this.state)
        .then((res) => {              
          if (res[0]==="serialeOperatore") {            
            localStorage.setItem('serialeOperatore', res[1]); // token      
            history.push(LANDING); // redirect a home page                                     
          } else 
          if(res[0]==="cambiaCredenziali") {
            history.push(CHANGE_PWD, { token: res[1] }); // redirect a cambia password
          } else {
            parent.setState({ showAlertBox : true });
          }
        })
        .catch((err) => { 
          console.log(err);          
        });    
    }
  }
}

export default withRouter(Login);


// WEBPACK FOOTER //
// ./src/cmp/Authentication/Login.js